<script>
export default {
  name: 'TwTransitionContainer',
  props: {
    animation: {
      type: String,
      default: 'default'
    }
  }
}
</script>

<template>
  <transition
    v-if="animation === 'default'"
    enter-active-class="transition ease-out duration-100"
    enter-from-class="transform opacity-0 scale-95"
    enter-to-class="transform opacity-100 scale-100"
    leave-active-class="transition ease-in duration-75"
    leave-from-class="transform opacity-100 scale-100"
    leave-to-class="transform opacity-0 scale-95"
  >
    <slot />
  </transition>
  <div v-else-if="animation === 'slide'" class="relative overflow-hidden transition-all duration-300 h-auto z-1">
    <transition
      enter-active-class="transition ease-out duration-300"
      enter-from-class="transform -translate-y-full opacity-0"
      enter-to-class="transform translate-y-0 opacity-100"
      leave-active-class="transition ease-in duration-300"
      leave-from-class="transform translate-y-0 opacity-100"
      leave-to-class="transform -translate-y-full opacity-0"
    >
      <slot />
    </transition>
  </div>
</template>

<style scoped>

</style>
